// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"adec1755","455":"8480f6f7","977":"b9520a19"}[chunkId] + ".chunk.js";
};